module.exports = __webpack_public_path__ + "static/media/purpose1.18400475.svg";